import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'brand-gravatar', 'BrandGravatar', [["path",{"d":"M5.64 5.632a9 9 0 1 0 6.36 -2.632v7.714"}]]);